import _ from 'underscore';
import moment from 'moment';

angular.module('am4').factory('calendarService', function($q, $http, apiUrl) {
    function mapEvents(events, month, timezone) {
        let _timezone = timezone || 'UTC',
            mappedEvents = _.map(events, function(event) {
                return {
                    id: event.id,
                    title: event.name,
                    description: event.description,
                    start: moment(event.startDate).tz(_timezone),
                    end: moment(event.endDate).tz(_timezone)
                };
            }),
            filteredEvents = _.filter(mappedEvents, function(event) {
                return event.start.month() === month || event.end.month() === month;
            });

        return filteredEvents;
    }

    return {
        getEventsInMonth: function(month, year, facility_id, timezone) {
            return $http({
                method: 'GET',
                url: apiUrl + '/facilities/' + facility_id + '/calendar',
                params: {
                    month: month,
                    year: year
                }
            })
            .then(function(res) {
                return mapEvents(res.data, month, timezone);
            });
        },
        getEventById: function(event_id, facility_id) {
            return $http.get(apiUrl + '/facilities/' + facility_id + '/calendar/events/' + event_id)
            .then(function(res) {
                return res.data;
            });
        },
        updateEvent: function(event_id, facility_id, data) {
            return $http.put(apiUrl + '/facilities/' + facility_id + '/calendar/events/' + event_id, data)
            .then(function(res) {
                return res.data;
            });
        },
        createEvent: function(facility_id, data) {
            return $http.post(apiUrl + '/facilities/' + facility_id + '/calendar/events/', data)
            .then(function(res) {
                return res.data;
            });
        },
        removeEvent: function(event_id, facility_id) {
            return $http.delete(apiUrl + '/facilities/' + facility_id + '/calendar/events/' + event_id)
            .then(function(res) {
                return res.data;
            });
        },
        getExternalCalendarId: function(facility_id) {
            return $http.get(apiUrl + '/facilities/' + facility_id + '/calendar/external')
            .then(function(res) {
                return res;
            });
        },
        addExternalCalendarId: function(facility_id, data) {
            return $http.post(apiUrl + '/facilities/' + facility_id + '/calendar/external', data)
            .then(function(res) {
                return res;
            });
        },
        removeExternalCalendarId: function(facility_id, data) {
            return $http.delete(apiUrl + '/facilities/' + facility_id + '/calendar/external', data)
            .then(function(res) {
                return res;
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/services/calendar.js